export enum SocialNetworkEntityType {
  WORKSPACE = 'WORKSPACE',
  GLOBAL = 'GLOBAL',
  INDUSTRY = 'INDUSTRY',
}
